// @flow

import store from 'app/store/AppStore';
import {WebSocketRouter} from 'app/ws/ws-router';
import {type PresenceMessageContentType} from './types';
import {
  receivePresenceMember,
  removePresenceMember,
  receivePresenceBeacon,
  receivePresenceAttend,
} from 'app/presence/actions';

export const presenceWebsocketRouter = new WebSocketRouter('presence');

presenceWebsocketRouter.register_handler(
  'join',
  (
    event: string,
    message: PresenceMessageContentType,
    sendMessage: (string) => void
  ) => {
    return store.dispatch(
      receivePresenceMember(event, message.data, sendMessage)
    );
  }
);

presenceWebsocketRouter.register_handler(
  'stealth_join',
  (
    event: string,
    message: PresenceMessageContentType,
    sendMessage: (string) => void
  ) => {
    return store.dispatch(
      receivePresenceMember(event, message.data, sendMessage)
    );
  }
);

presenceWebsocketRouter.register_handler(
  'leave',
  (event: string, message: PresenceMessageContentType) => {
    return store.dispatch(removePresenceMember(message.data));
  }
);

presenceWebsocketRouter.register_handler(
  'beacon',
  (event: string, message: PresenceMessageContentType) => {
    return store.dispatch(receivePresenceBeacon(message.data));
  }
);

presenceWebsocketRouter.register_handler(
  'attend',
  (event: string, message: PresenceMessageContentType) => {
    return store.dispatch(receivePresenceAttend(message.data));
  }
);
